import { Route, Routes } from 'react-router-dom'
import { ErrorBoundary } from 'react-error-boundary'
import { ToastContainer } from 'src/toast'
import { Aside, ErrorNotFound, Main } from 'src/components'
import Landing from './Landing'
import Onboarding from './Onboarding'
import SetupSaml from './SetupSAML'
import SetupCcp from './SetupCCP'
import SetupSso from './SetupSSO'
import Organization from './Organization'
import Marketplace from './Marketplace'
import SetupSalesforce from './Salesforce'
import Help from './Help'
import { ErrorFallback } from './Errors'
import { savedTokens } from 'src/auth'
import { useLogging } from './Logging/queries'
import { savedOrganization } from './Onboarding/storage'

export default function Router() {
  const logger = useLogging()

  return (
    <div className="flex flex-col w-screen min-h-screen">
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onReset={() => {
          window.location.reload()
        }}
        onError={(error, info) => {
          if (process.env.NODE_ENV === 'production') {
            const tokens = savedTokens.get()

            logger.mutate({
              type: 'error',
              location: window.location.href,
              message: `${error.name}: ${error.message}`,
              stack: info.componentStack,
              organization:
                tokens?.organization ?? savedOrganization.get() ?? '-',
            })
          }
        }}
      >
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="help/*">
            <Route index element={<Help />} />
            <Route path="admin" element={<Help isAdmin />} />
          </Route>
          <Route path="marketplace" element={<Marketplace />} />
          <Route path="onboarding/*" element={<Onboarding />} />
          <Route path="setup-saml/*" element={<SetupSaml />} />
          <Route path="setup-ccp/*" element={<SetupCcp />} />
          <Route path="setup-sso/*" element={<SetupSso />} />
          <Route path="setup-salesforce/*" element={<SetupSalesforce />} />
          <Route
            path="org/:orgId/*"
            element={<Organization />}
            /*
          element={
            <AuthWall>
              <Organization />
            </AuthWall>
          }
          */
          />
          <Route
            path="*"
            element={
              <>
                <Aside title="Provisioning" hideExtraRow />
                <Main>
                  <ErrorNotFound />
                </Main>
              </>
            }
          />
        </Routes>

        <ToastContainer />
      </ErrorBoundary>
    </div>
  )
}
